import { render } from "./courtyard.svg?vue&type=template&id=13a0ecda"
const script = {}
script.render = render

export default script